import { styled } from '@linaria/react';

import { COLORS_MAP, type CommonProps } from '../constants';

export const SIZES = [undefined, 'L', 'M', 'S'] as const;
export type TSize = (typeof SIZES)[number];

const FONT_SIZES = {
	S: '0.8rem',
	M: '1.0rem',
	L: '1.2rem',
};

const LINE_HEIGHTS = {
	S: '1.2rem',
	M: '1.6rem',
	L: '1.6rem',
};

export const Captions = styled.p<
	CommonProps<TSize> & {
		brandedLink?: boolean;
		underline?: boolean;
	}
>`
	color: ${({ color }) => (color ? COLORS_MAP[color] : 'inherit')};
	font-size: ${({ size = 'M' }) => FONT_SIZES[size]};
	font-weight: var(--font-weight-medium);
	line-height: ${({ size = 'M' }) => LINE_HEIGHTS[size]};

	text-align: ${({ align }) => align ?? 'center'};
	text-transform: ${({ transform }) => transform ?? 'inherit'};
	white-space: ${({ multiline }) => (multiline ? 'pre-wrap' : 'inherit')};
	word-break: ${({ multiline }) => (multiline ? 'break-word' : 'inherit')};
	&::first-letter {
		text-transform: ${({ capitalizeFirstLetter }) =>
			capitalizeFirstLetter ? 'uppercase' : 'inherit'};
	}

	a {
		/* stylelint-disable */
		color: ${({ color, brandedLink }) => {
			if (brandedLink) return 'var(--color-rose-58-solid)';
			if (color) return COLORS_MAP[color];
			return 'var(--color-white-solid)';
		}};
		/* stylelint-enable */
		cursor: pointer;
		font-weight: ${({ brandedLink }) =>
			brandedLink ? 'var(--font-weight-semibold)' : 'inherit'};
		text-decoration: ${({ underline }) => (underline ? 'underline' : 'auto')};
		&:hover {
			color: var(--color-white-solid);
			text-decoration: underline;
		}
	}
`;
